/**
 * tool工具包
 * wiz-utils、wiz-components、wiz-frameworks工具的统一出口
 * 为了优化开发效率，暂时将三个工具包迁入此处，待基本开发完成，工具包成熟后再分出
 * @author mll
 * @date 2019-12-19
 */


// import * as framework_tool from '@/tool/wiz-frameworks'
// import * as component_tool from '@/tool/wiz-components/src'
// import * as utils_tool from '@/tool/wiz-utils/src'
// let component_tool = component.default


import * as framework_tool from 'wiz-frameworks'
import component_tool from 'wiz-components'
import utils_tool from 'wiz-utils'

export {
    framework_tool,
    utils_tool,
    component_tool
}